import { messageType } from "api/interfaces/message.type";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { ReactNode } from "react";
import styles from "./messageCard.module.scss";

interface IProps {
    message: string | ReactNode;
    subtext?: string | ReactNode;
    type: messageType;
    className?: string;
}

function MessageCard(props: IProps) {
  const {
    message, subtext, type, className = "",
  } = props;
  const iconColorMap: Record<messageType, string> = {
    primary: "#1a4d7c",
    success: "#28a74551",
    error: "#dc364551",
    warning: "#ffc10751",
    info: "#1a4d7c",
  };

  return (
    <div className={`${styles.container} ${styles[`message--${type}`]} ${className}`}>
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="20" viewBox="0 0 24 24" fill="none" stroke={iconColorMap[type]} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
      </svg>
      <div>
        <PAText className={`m-b-0 d-flex ${styles.message}`} component="div" fontSize={FONT_SIZE[0]} color="pa-blue" bold>{message}</PAText>
        <PAText component="div" color="pa-blue" fontSize={FONT_SIZE[0]}>{subtext}</PAText>
      </div>
    </div>
  );
}

export default MessageCard;
